import Auth_API from "./apiConfig";
// Centralized Error Handling
const handleError = (error) => {
  if (error.response) {
    console.error("Server Error:", error.response.data.message || error.response.statusText);
    throw new Error(error?.response.data.message || "Server Error");
  } else if (error.request) {
    console.error("Network Error:", error.message);
    throw new Error("Network Error. Please check your connection.");
  } else {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

// Services
export const getAllServices = async (params) => {
  try {
    const response = await Auth_API.get(`bazaar/services`, { params });
    return response.data.response;
  } catch (error) {
    handleError(error);
  }
};

export const getFilteredServices = async (word) => {
  try {
    const response = await Auth_API.get(`bazaar/services?title=${word}&limit=10000`);
    return response.data.response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUserService = async (sId) => {
  try {
    const response = await Auth_API.get(`/bazaar/services/${sId}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


export const getSellerDashboard = async () => {
  try {
    const response = await Auth_API.get('bazaar/services/seller/dashboard?type=seller');
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getIndustries = async () => {
  try {
    const response = await Auth_API.post('/config/type/industries');
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


export const createService = async (f_data) => {
  try {
    const response = await Auth_API.post('bazaar/services', f_data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateService = async (id, u_data) => {
  try {
    const response = await Auth_API.put(`bazaar/services/update/${id}`, u_data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteMyService = async (service_Id) => {
  try {
    const response = await Auth_API.delete(`bazaar/services/${service_Id}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


// api/appointment/meeting/feedback/:appointmentId
export const OrderDealCreate = async ({ appointmentId, body }) => {
  try {
    const response = await Auth_API.post(
      `appointment/meeting/feedback/${appointmentId}`,
      body
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Orders
export const getSellerOrders = async (params) => {
  try {
    const response = await Auth_API.get(`bazaar/orders`, { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateOrderStatus = async (params) => {
  try {
    const response = await Auth_API.put(`/bazaar/orders?order_id=${params.order_id}&type=${params.type}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAllOrders = async (params) => {
  try {
    const response = await Auth_API.get('/bazaar/orders', { params });
    return response.data.response;
  } catch (error) {
    handleError(error);
  }
};

export const getAllAppointments = async (params) => {
  try {
    const response = await Auth_API.get(`/appointment`, { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAllSellerAppointments = async (params) => {
  try {
    const response = await Auth_API.get(`appointment`, { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const createAppointment = async (params) => {
  try {
    const response = await Auth_API.post('/appointment', params);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const rescheduleAppointment = async (id, data) => {
  try {
    const response = await Auth_API.put(`appointment/${id}`, data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const actionAppointment = async (appointmentID, action) => {
  try {
    const data = {
      actionType: action,
      appointmentId: appointmentID,
    };
    const response = await Auth_API.post(`appointment/action`, data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getLocations = async (params) => {
  try {
    // console.log("Fetching locations with params:", params);
    const response = await Auth_API.get(`bazaar/locations`,{params});
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
  
export const getIndustry = async () => {
  try {
    const response = await Auth_API.get(`bazaar/industries`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUpcomingAppointment = async (params) => {
  try {
    const response = await Auth_API.get(`bazaar/services/upcoming/orders-appointment`,{params});
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getSellers = async (params) => {
  try {
    const response = await Auth_API.get('bazaar/services/seller/profiles', { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const checkBuyerPendingOrder = async () => {
  try {
    const response = await Auth_API.get(`/appointment/orders/check/pending`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAllServicesBySellerType = async (params) => {
  try {
    const response = await Auth_API.get(`bazaar/services`, { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getServicesByLI = async (industries, locations) => {
  try {
    const response = await Auth_API.get(`bazaar/services?industry[]=${industries}&location[]=${locations}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


export const getServiceById = async (id) => {
  try {
    const response = await Auth_API.get(`bazaar/services/${id}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getOrderByServiceId = async (id) => {
  try {
    const response = await Auth_API.get(`bazaar/orders/service?service_id=${id}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};